/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module NavigationModule
 * @preferred
 */

import {
    CUSTOM_ELEMENTS_SCHEMA,
    NgModule,
} from '@angular/core';
import { VIPModule } from '@vmw/ngx-vip';
import { UIRouterModule } from '@uirouter/angular';
import {
    ClrIconModule,
    ClrVerticalNavModule,
} from '@clr/angular';

import { SharedModule } from 'ng/shared/shared.module';
import { AviFormsModule } from 'ng/modules/avi-forms/avi-forms.module';

import {
    AdministrationVerticalNavComponent,
    ApplicationsVerticalNavComponent,
    AviSkipLinkComponent,
    GslbServiceSubheaderComponent,
    InfrastructureVerticalNavComponent,
    OperationsVerticalNavComponent,
    PoolSubheaderComponent,
    SubheaderNavComponent,
    TemplatesVerticalNavComponent,
    VerticalNavComponent,
    VerticalNavGroupComponent,
    VirtualServiceSubheaderComponent,
} from './components';

import {
    IsActiveStatePipe,
    StateNameToPermissionPipe,
} from './pipes';

const navigationComponents = [
    AdministrationVerticalNavComponent,
    ApplicationsVerticalNavComponent,
    AviSkipLinkComponent,
    GslbServiceSubheaderComponent,
    InfrastructureVerticalNavComponent,
    OperationsVerticalNavComponent,
    PoolSubheaderComponent,
    SubheaderNavComponent,
    TemplatesVerticalNavComponent,
    VerticalNavComponent,
    VerticalNavGroupComponent,
    VirtualServiceSubheaderComponent,
];

const navigationPipes = [
    IsActiveStatePipe,
    StateNameToPermissionPipe,
];

@NgModule({
    declarations: [
        ...navigationComponents,
        ...navigationPipes,
    ],
    exports: [
        AdministrationVerticalNavComponent,
        ApplicationsVerticalNavComponent,
        AviSkipLinkComponent,
        GslbServiceSubheaderComponent,
        InfrastructureVerticalNavComponent,
        OperationsVerticalNavComponent,
        PoolSubheaderComponent,
        TemplatesVerticalNavComponent,
        VirtualServiceSubheaderComponent,
    ],
    imports: [
        ClrIconModule,
        ClrVerticalNavModule,
        VIPModule.forChild(),
        UIRouterModule,
        SharedModule,
        AviFormsModule,
    ],
    providers: [
        IsActiveStatePipe,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class NavigationModule {}
